module.exports = __webpack_public_path__ + "static/icons/icon-home-95a2248e41e55d774391cadca2cab975.svg";